
// import React, { useState } from 'react';
// import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   Toolbar,
//   Typography,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Avatar,
//   Menu,
//   MenuItem,
//   Divider,
//   Tooltip,
//   alpha,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   CircularProgress,
//   Alert,
// } from '@mui/material';
// import {
//   Menu as MenuIcon,
//   Dashboard as DashboardIcon,
//   Business as VendorsIcon,
//   Assessment as ScansIcon,
//   BarChart as ReportsIcon,
//   CompareArrows as CompareArrowsIcon,
//   Settings as SettingsIcon,
//   Person as PersonIcon,
//   Logout as LogoutIcon,
//   NotificationsActive as MonitoringIcon,
//   Add as AddIcon,
//   People as PeopleIcon,
//   History as HistoryIcon,
//   Brightness4 as DarkModeIcon,
//   Brightness7 as LightModeIcon,
//   Quiz as QuestionnaireIcon,
//   Lock as LockIcon,
// } from '@mui/icons-material';
// import { useAuth } from '../context/AuthContext';
// import { useTheme } from '../context/ThemeContext';
// import AlertBell from '../components/AlertBell';
// import ProfileDrawer from '../components/ProfileDrawer';
// import api from '../services/api';

// const drawerWidth = 250;
// const collapsedDrawerWidth = 65;

// const menuItems = [
//   { path: '/', label: 'Dashboard', icon: DashboardIcon },
//   { path: '/vendors', label: 'Vendors', icon: VendorsIcon },
//   { path: '/vendors/add', label: 'Add Vendor', icon: AddIcon },
//   { path: '/monitoring', label: 'Monitoring', icon: MonitoringIcon },
//   { path: '/scans', label: 'Scan', icon: ScansIcon },
//   { path: '/reports', label: 'Reports', icon: ReportsIcon },
//   { path: '/reports/comparison', label: 'Vendor Comparison', icon: CompareArrowsIcon },
//   { path: '/users', label: 'Team', icon: PeopleIcon },
//   { path: '/questionnaires', label: 'Questionnaires', icon: QuestionnaireIcon },
//   { path: '/audit-logs', label: 'Audit Logs', icon: HistoryIcon },
//   { path: '/settings', label: 'Settings', icon: SettingsIcon },
// ];

// // ─── CHANGE PASSWORD DIALOG COMPONENT ─────────────────────────────────────
// const ChangePasswordDialog: React.FC<{
//   open: boolean;
//   onClose: () => void;
//   isDark: boolean;
// }> = ({ open, onClose, isDark }) => {
//   const [currentPassword, setCurrentPassword] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState(false);

//   const colors = {
//     text: isDark ? '#e2e8f0' : '#0f172a',
//     muted: isDark ? '#94a3b8' : '#64748b',
//     background: isDark ? '#0d0d0d' : '#ffffff',
//     border: isDark ? '#1f1f1f' : '#e2e8f0',
//     inputBg: isDark ? '#0d0d0d' : '#ffffff',
//   };

//   const inputSx = {
//     '& .MuiOutlinedInput-root': {
//       color: colors.text,
//       bgcolor: colors.inputBg,
//       '& fieldset': { borderColor: colors.border },
//       '&:hover fieldset': { borderColor: isDark ? '#333333' : colors.muted },
//       '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
//     },
//     '& .MuiInputLabel-root': { color: colors.muted },
//     '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
//   };

//   const handleClose = () => {
//     setError('');
//     setSuccess(false);
//     setCurrentPassword('');
//     setNewPassword('');
//     setConfirmPassword('');
//     onClose();
//   };

//   const handleSubmit = async () => {
//     if (newPassword.length < 6) {
//       setError('Password must be at least 6 characters');
//       return;
//     }
//     if (newPassword !== confirmPassword) {
//       setError('Passwords do not match');
//       return;
//     }

//     setLoading(true);
//     setError('');
//     setSuccess(false);

//     try {
//       await api.post('/v1/auth/change-password', {
//         current_password: currentPassword,
//         new_password: newPassword,
//       });
//       setSuccess(true);
//       setCurrentPassword('');
//       setNewPassword('');
//       setConfirmPassword('');
//       setTimeout(() => {
//         handleClose();
//       }, 1500);
//     } catch (err: any) {
//       console.error('Change password error:', err);
      
//       let errorMessage = 'Failed to change password. Please try again.';
      
//       if (err.response?.data?.detail) {
//         const detail = err.response.data.detail;
        
//         if (typeof detail === 'string') {
//           errorMessage = detail;
//         } else if (Array.isArray(detail)) {
//           const messages = detail.map((e: any) => {
//             if (typeof e === 'string') return e;
//             if (e.msg) return e.msg;
//             if (e.message) return e.message;
//             return 'Invalid value';
//           });
//           errorMessage = messages.join('; ');
//         } else if (typeof detail === 'object') {
//           try {
//             errorMessage = JSON.stringify(detail);
//           } catch {
//             errorMessage = 'Validation error occurred';
//           }
//         }
//       } else if (err.message) {
//         errorMessage = err.message;
//       }
      
//       setError(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           bgcolor: colors.background,
//           border: `1px solid ${colors.border}`,
//           borderRadius: 2,
//         }
//       }}
//     >
//       <DialogTitle sx={{ 
//         color: colors.text, 
//         borderBottom: `1px solid ${colors.border}`,
//         fontWeight: 600,
//       }}>
//         Change Password
//       </DialogTitle>
//       <DialogContent sx={{ pt: 3 }}>
//         {success && (
//           <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
//             Password changed successfully!
//           </Alert>
//         )}
//         {error && (
//           <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
//             {error}
//           </Alert>
//         )}
//         <TextField
//           fullWidth
//           label="Current Password"
//           type="password"
//           value={currentPassword}
//           onChange={(e) => setCurrentPassword(e.target.value)}
//           sx={{ mb: 2, ...inputSx }}
//         />
//         <TextField
//           fullWidth
//           label="New Password"
//           type="password"
//           value={newPassword}
//           onChange={(e) => setNewPassword(e.target.value)}
//           sx={{ mb: 2, ...inputSx }}
//           helperText="Minimum 6 characters"
//         />
//         <TextField
//           fullWidth
//           label="Confirm New Password"
//           type="password"
//           value={confirmPassword}
//           onChange={(e) => setConfirmPassword(e.target.value)}
//           sx={{ ...inputSx }}
//         />
//       </DialogContent>
//       <DialogActions sx={{ 
//         p: 2, 
//         gap: 1, 
//         borderTop: `1px solid ${colors.border}` 
//       }}>
//         <Button
//           onClick={handleClose}
//           sx={{ 
//             color: colors.muted,
//             '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)' },
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={loading}
//           sx={{
//             bgcolor: '#3b82f6',
//             '&:hover': { bgcolor: '#2563eb' },
//             '&.Mui-disabled': { bgcolor: isDark ? '#1a1a1a' : '#e5e7eb' },
//             textTransform: 'none',
//             fontWeight: 600,
//           }}
//         >
//           {loading ? <CircularProgress size={20} /> : 'Change Password'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default function MainLayout() {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [isHovering, setIsHovering] = useState(false);
//   const [isLocked, setIsLocked] = useState(false);
//   const [changePasswordOpen, setChangePasswordOpen] = useState(false);
//   const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
//   const [profileDrawerView, setProfileDrawerView] = useState<'profile' | 'account'>('profile');
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user, logout } = useAuth();
//   const { mode, toggleTheme } = useTheme();
//   const isDark = mode === 'dark';

//   // ─── Theme-aware color tokens ────────────────────────────────────
//   const colors = {
//     appBarBg: isDark ? '#000000' : '#FFFFFF',
//     appBarBorder: isDark ? '#1F1F1F' : '#E0E0E0',
//     appBarText: isDark ? '#FFFFFF' : '#333333',
//     hamburgerIdle: isDark ? '#FFFFFF' : '#333333',
//     hamburgerHover: isDark ? alpha('#FFFFFF', 0.08) : alpha('#000', 0.05),
//     sidebarBg: isDark ? '#000000' : '#FFFFFF',
//     sidebarBorder: isDark ? '#1F1F1F' : '#d4d4d4',
//     sidebarDivider: isDark ? '#1F1F1F' : '#c9c9c9',
//     textColor: isDark ? '#FFFFFF' : '#000000',
//     hoverBgColor: isDark ? alpha('#2B5C9E', 0.25) : alpha('#2B5C9E', 0.1),
//     activeBgColor: '#2B5C9E',
//     activeTextColor: '#FFFFFF',
//     userName: isDark ? '#FFFFFF' : '#000000',
//     userSubtext: isDark ? '#9A9FBE' : '#8A8FAB',
//     mainBg: isDark ? '#000000' : '#F5F6FA',
//     accent: '#2B5C9E',
//     menuBg: isDark ? '#0F0F0F' : '#FFFFFF',
//     menuText: isDark ? '#FFFFFF' : '#000000',
//     menuBorder: isDark ? '#1F1F1F' : '#e0e0e0',
//   };

//   const logoSrc = isDark ? '/logo2.png' : '/logo.png';

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handleSidebarToggle = () => {
//     if (isLocked) {
//       setIsLocked(false);
//       setSidebarOpen(false);
//     } else {
//       setIsLocked(true);
//       setSidebarOpen(true);
//     }
//   };

//   const handleMouseEnter = () => {
//     if (!isLocked) {
//       setIsHovering(true);
//       setSidebarOpen(true);
//     }
//   };

//   const handleMouseLeave = () => {
//     if (!isLocked) {
//       setIsHovering(false);
//       setSidebarOpen(false);
//     }
//   };

//   const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = () => {
//     handleMenuClose();
//     logout();
//     navigate('/login');
//   };

//   const handleChangePassword = () => {
//     handleMenuClose();
//     setChangePasswordOpen(true);
//   };

//   const handleOpenProfileDrawer = () => {
//     handleMenuClose();
//     setProfileDrawerView('profile');
//     setProfileDrawerOpen(true);
//   };

//   const handleOpenAccountSettings = () => {
//     handleMenuClose();
//     setProfileDrawerView('account');
//     setProfileDrawerOpen(true);
//   };

//   const isActivePath = (path: string) => {
//     if (path === '/') return location.pathname === '/';
//     if (path === '/reports') return location.pathname === '/reports';
//     if (path === '/reports/comparison') return location.pathname === '/reports/comparison';
//     if (path === '/monitoring') return location.pathname === '/monitoring';
//     if (path === '/vendors/add') return location.pathname === '/vendors/add';
//     if (path === '/vendors') return location.pathname === '/vendors';
//     if (path === '/scans') return location.pathname.startsWith('/scans');
//     if (path === '/users') return location.pathname.startsWith('/users');
//     if (path === '/audit-logs') return location.pathname.startsWith('/audit-logs');
//     return location.pathname.startsWith(path);
//   };

//   const isVisible = sidebarOpen || isHovering || isLocked;

//   const drawerContent = (
//     <Box
//       sx={{
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         overflowX: 'hidden',
//         pt: 1,
//         bgcolor: colors.sidebarBg,
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: 20,
//         }}
//       />

//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           overflowX: 'hidden',
//         }}
//       >
//         <List sx={{ px: isVisible ? 2 : 1, py: 2, flex: 1 }}>
//           {menuItems.map((item) => {
//             const isActive = isActivePath(item.path);

//             return (
//               <ListItem key={item.path} disablePadding sx={{
//                 mb: 1,
//                 justifyContent: isVisible ? 'flex-start' : 'center',
//               }}>
//                 <ListItemButton
//                   onClick={() => navigate(item.path)}
//                   sx={{
//                     borderRadius: 0,
//                     py: 1.2,
//                     justifyContent: isVisible ? 'flex-start' : 'center',
//                     px: isVisible ? 2 : 1,
//                     bgcolor: isActive ? colors.activeBgColor : 'transparent',
//                     color: isActive ? colors.activeTextColor : colors.textColor,
//                     '&:hover': {
//                       bgcolor: isActive ? colors.activeBgColor : colors.hoverBgColor,
//                       color: isActive ? colors.activeTextColor : (isDark ? '#FFFFFF' : '#0f172a'),
//                     },
//                     '&:hover .MuiListItemIcon-root': {
//                       color: isActive ? colors.activeTextColor : (isDark ? '#FFFFFF' : '#0f172a'),
//                     },
//                   }}
//                 >
//                   <ListItemIcon sx={{
//                     color: 'inherit',
//                     minWidth: isVisible ? 40 : 'auto',
//                     justifyContent: 'center',
//                   }}>
//                     <item.icon />
//                   </ListItemIcon>
//                   {isVisible && (
//                     <ListItemText
//                       primary={item.label}
//                       primaryTypographyProps={{
//                         fontSize: '0.875rem',
//                         fontWeight: isActive ? 600 : 400,
//                       }}
//                     />
//                   )}
//                 </ListItemButton>
//               </ListItem>
//             );
//           })}
//         </List>

//         {user && (
//           <>
//             <Divider sx={{ borderColor: colors.sidebarDivider }} />
//             <Box sx={{ p: isVisible ? 2 : 1.5, mt: 'auto' }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: isVisible ? 'flex-start' : 'center',
//                   gap: isVisible ? 2 : 1,
//                   p: isVisible ? 1.5 : 1,
//                 }}
//               >
//                 <Avatar sx={{
//                   bgcolor: colors.accent,
//                   width: isVisible ? 40 : 32,
//                   height: isVisible ? 40 : 32,
//                   borderRadius: '50%',
//                   color: '#FFFFFF',
//                 }}>
//                   {user.name?.charAt(0).toUpperCase()}
//                 </Avatar>
//                 {isVisible && (
//                   <Box>
//                     <Typography variant="body2" fontWeight={600} sx={{ color: colors.userName }}>
//                       {user.name}
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: colors.userSubtext }}>
//                       {user.company || 'Risk Manager'}
//                     </Typography>
//                   </Box>
//                 )}
//               </Box>
//             </Box>
//           </>
//         )}
//       </Box>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <CssBaseline />

//       {/* ─── CHANGE PASSWORD DIALOG ──────────────────────────────────── */}
//       <ChangePasswordDialog
//         open={changePasswordOpen}
//         onClose={() => setChangePasswordOpen(false)}
//         isDark={isDark}
//       />

//       {/* ─── PROFILE DRAWER ──────────────────────────────────────────── */}
//       <ProfileDrawer
//         open={profileDrawerOpen}
//         onClose={() => setProfileDrawerOpen(false)}
//         onOpenChangePassword={handleChangePassword}
//         initialView={profileDrawerView}
//       />

//       <AppBar
//         position="fixed"
//         sx={{
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//           boxShadow: 'none',
//           borderBottom: '1px solid',
//           borderBottomColor: colors.appBarBorder,
//           bgcolor: colors.appBarBg,
//           color: colors.appBarText,
//           height: 64,
//         }}
//       >
//         <Toolbar sx={{ height: 64, minHeight: 64 }}>
//           <IconButton
//             onClick={handleSidebarToggle}
//             edge="start"
//             sx={{
//               color: isLocked ? colors.accent : colors.hamburgerIdle,
//               mr: 2,
//               '&:hover': { bgcolor: colors.hamburgerHover },
//             }}
//           >
//             <MenuIcon />
//           </IconButton>

//           <Box
//             component="img"
//             src={logoSrc}
//             alt="Axentro"
//             sx={{
//               height: isDark ? 115 : 80,
//               width: 'auto',
//               objectFit: 'contain',
//             }}
//           />

//           <Box sx={{ flexGrow: 1 }} />

//           <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
//             <IconButton
//               onClick={toggleTheme}
//               sx={{
//                 color: colors.hamburgerIdle,
//                 mr: 1,
//                 '&:hover': { bgcolor: colors.hamburgerHover },
//               }}
//             >
//               {isDark ? <LightModeIcon /> : <DarkModeIcon />}
//             </IconButton>
//           </Tooltip>

//           <AlertBell />

//           <Tooltip title="Account">
//             <IconButton onClick={handleMenuOpen} sx={{ ml: 1 }}>
//               <Avatar sx={{ width: 32, height: 32, bgcolor: colors.accent, borderRadius: 50, color: '#FFFFFF' }}>
//                 {user?.name?.charAt(0).toUpperCase() || <PersonIcon />}
//               </Avatar>
//             </IconButton>
//           </Tooltip>

//           <Menu
//             anchorEl={anchorEl}
//             open={Boolean(anchorEl)}
//             onClose={handleMenuClose}
//             transformOrigin={{ horizontal: 'right', vertical: 'top' }}
//             anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//             PaperProps={{
//               sx: {
//                 width: 220,
//                 mt: 1,
//                 bgcolor: colors.menuBg,
//                 color: colors.menuText,
//                 border: `1px solid ${colors.menuBorder}`,
//               },
//             }}
//           >
//             <MenuItem 
//               onClick={handleOpenProfileDrawer}
//               sx={{
//                 '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
//               }}
//             >
//               <ListItemIcon><PersonIcon fontSize="small" sx={{ color: colors.menuText }} /></ListItemIcon>
//               <ListItemText sx={{ color: colors.menuText }}>Profile</ListItemText>
//             </MenuItem>
            
//             <MenuItem 
//               onClick={handleChangePassword}
//               sx={{
//                 '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
//               }}
//             >
//               <ListItemIcon><LockIcon fontSize="small" sx={{ color: colors.menuText }} /></ListItemIcon>
//               <ListItemText sx={{ color: colors.menuText }}>Change Password</ListItemText>
//             </MenuItem>
            
//             <MenuItem 
//               onClick={handleOpenAccountSettings}
//               sx={{
//                 '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
//               }}
//             >
//               <ListItemIcon><SettingsIcon fontSize="small" sx={{ color: colors.menuText }} /></ListItemIcon>
//               <ListItemText sx={{ color: colors.menuText }}>Account Settings</ListItemText>
//             </MenuItem>
            
//             <Divider sx={{ borderColor: colors.menuBorder }} />
            
//             <MenuItem 
//               onClick={handleLogout} 
//               sx={{ 
//                 color: 'error.main',
//                 '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
//               }}
//             >
//               <ListItemIcon><LogoutIcon fontSize="small" sx={{ color: 'error.main' }} /></ListItemIcon>
//               <ListItemText primary="Logout" primaryTypographyProps={{ color: 'error.main' }} />
//             </MenuItem>
//           </Menu>
//         </Toolbar>
//       </AppBar>

//       <Box
//         component="nav"
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//         sx={{
//           width: { sm: isVisible ? drawerWidth : collapsedDrawerWidth },
//           flexShrink: { sm: 0 },
//           transition: 'width 0.2s ease-out',
//           mt: '64px',
//         }}
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: 'block', sm: 'none' },
//             '& .MuiDrawer-paper': {
//               boxSizing: 'border-box',
//               width: drawerWidth,
//               bgcolor: colors.sidebarBg,
//               borderRight: 'none',
//               borderRadius: 0,
//               mt: '64px',
//               height: 'calc(100vh - 64px)',
//             },
//           }}
//         >
//           {drawerContent}
//         </Drawer>

//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: 'none', sm: 'block' },
//             '& .MuiDrawer-paper': {
//               boxSizing: 'border-box',
//               width: isVisible ? drawerWidth : collapsedDrawerWidth,
//               bgcolor: colors.sidebarBg,
//               borderRight: '1px solid',
//               borderRightColor: colors.sidebarBorder,
//               position: 'fixed',
//               height: 'calc(100vh - 64px)',
//               top: 64,
//               left: 0,
//               overflowX: 'hidden',
//               borderRadius: 0,
//               transition: 'width 0.2s ease-out, background-color 0.2s ease-out',
//             },
//           }}
//           open
//         >
//           {drawerContent}
//         </Drawer>
//       </Box>

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           width: { sm: `calc(100% - ${isVisible ? drawerWidth : collapsedDrawerWidth}px)` },
//           bgcolor: colors.mainBg,
//           minHeight: '100vh',
//           mt: '64px',
//           transition: 'width 0.2s ease-out, background-color 0.2s ease-out',
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Tooltip,
  alpha,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Alert,
  Badge,
} from '@mui/material';
import {
  Menu as MenuIcon,
  SpaceDashboardOutlined as DashboardIcon,
  ApartmentOutlined as VendorsIcon,
  PersonAddAltOutlined as VendorRequestsIcon,
  BarChartOutlined as ReportsIcon,
  CompareArrowsOutlined as CompareArrowsIcon,
  Settings as SettingsIcon,
  SettingsOutlined as SettingsNavIcon,
  Person as PersonIcon,
  Logout as LogoutIcon,
  NotificationsNoneOutlined as MonitoringIcon,
  CalendarMonthOutlined as ScheduleIcon,
  AddBusinessOutlined as AddIcon,
  GroupOutlined as PeopleIcon,
  HistoryOutlined as HistoryIcon,
  Brightness4 as DarkModeIcon,
  Brightness7 as LightModeIcon,
  Lock as LockIcon,
  FactCheckOutlined as QuestionnaireIcon,
  BuildOutlined as RemediationIcon,
  HubOutlined as FourthPartiesIcon,
  HelpOutlineOutlined as HelpIcon,
} from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { helpQueries, vendorRequestQueries } from '../lib/queries';
import { useRealtimeSync } from '../lib/realtime';
import ProfileDrawer from '../components/ProfileDrawer';
import NotificationBell from '../components/NotificationBell';
import OrganizationButton from '../components/OrganizationButton';
import TrialBadge from '../components/TrialBadge';
import FluxAssistant from '../components/FluxAssistant';
import IdleSignOut from '../components/IdleSignOut';
import AIGuardModal from '../components/AIGuardModal';
import api from '../services/api';

const drawerWidth = 250;
const collapsedDrawerWidth = 72;

type MenuItem = { path: string; label: string; icon: typeof DashboardIcon };

// Grouped into labelled sections; a section with no title sits at the top on its own.
const menuSections: { title: string | null; items: MenuItem[] }[] = [
  { title: null, items: [
    { path: '/', label: 'Dashboard', icon: DashboardIcon },
  ] },
  { title: 'Vendors', items: [
    { path: '/vendors', label: 'Vendors', icon: VendorsIcon },
    { path: '/vendors/add', label: 'Add Vendor', icon: AddIcon },
    { path: '/vendor-requests', label: 'Pre Onboarding', icon: VendorRequestsIcon },
    { path: '/questionnaire-library', label: 'Questionnaire Library', icon: QuestionnaireIcon },
  ] },
  { title: 'Risk', items: [
    { path: '/remediation', label: 'Remediation', icon: RemediationIcon },
    { path: '/monitoring', label: 'Alerting', icon: MonitoringIcon },
    { path: '/schedule', label: 'Schedule', icon: ScheduleIcon },
  ] },
  { title: 'Insights', items: [
    { path: '/reports', label: 'Reports', icon: ReportsIcon },
    { path: '/reports/comparison', label: 'Vendor Comparison', icon: CompareArrowsIcon },
    { path: '/fourth-parties', label: 'Fourth Parties', icon: FourthPartiesIcon },
  ] },
  { title: 'Workspace', items: [
    { path: '/users', label: 'Team', icon: PeopleIcon },
    { path: '/audit-logs', label: 'Audit Logs', icon: HistoryIcon },
    { path: '/settings', label: 'Settings', icon: SettingsNavIcon },
  ] },
];

// ─── CHANGE PASSWORD DIALOG COMPONENT ─────────────────────────────────────
const ChangePasswordDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  isDark: boolean;
}> = ({ open, onClose, isDark }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const colors = {
    text: isDark ? '#e2e8f0' : '#0f172a',
    muted: isDark ? '#94a3b8' : '#64748b',
    background: isDark ? '#0d0d0d' : '#ffffff',
    border: isDark ? '#1f1f1f' : '#e2e8f0',
    inputBg: isDark ? '#0d0d0d' : '#ffffff',
  };

  const inputSx = {
    '& .MuiOutlinedInput-root': {
      color: colors.text,
      bgcolor: colors.inputBg,
      '& fieldset': { borderColor: colors.border },
      '&:hover fieldset': { borderColor: isDark ? '#333333' : colors.muted },
      '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
    },
    '& .MuiInputLabel-root': { color: colors.muted },
    '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
  };

  const handleClose = () => {
    setError('');
    setSuccess(false);
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    onClose();
  };

  const handleSubmit = async () => {
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await api.post('/v1/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
      });
      setSuccess(true);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => {
        handleClose();
      }, 1500);
    } catch (err: any) {
      console.error('Change password error:', err);
      
      let errorMessage = 'Failed to change password. Please try again.';
      
      if (err.response?.data?.detail) {
        const detail = err.response.data.detail;
        
        if (typeof detail === 'string') {
          errorMessage = detail;
        } else if (Array.isArray(detail)) {
          const messages = detail.map((e: any) => {
            if (typeof e === 'string') return e;
            if (e.msg) return e.msg;
            if (e.message) return e.message;
            return 'Invalid value';
          });
          errorMessage = messages.join('; ');
        } else if (typeof detail === 'object') {
          try {
            errorMessage = JSON.stringify(detail);
          } catch {
            errorMessage = 'Validation error occurred';
          }
        }
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: colors.background,
          border: `1px solid ${colors.border}`,
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{ 
        color: colors.text, 
        borderBottom: `1px solid ${colors.border}`,
        fontWeight: 600,
      }}>
        Change Password
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        {success && (
          <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
            Password changed successfully!
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          fullWidth
          label="Current Password"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          sx={{ mb: 2, ...inputSx }}
        />
        <TextField
          fullWidth
          label="New Password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          sx={{ mb: 2, ...inputSx }}
          helperText="Minimum 6 characters"
        />
        <TextField
          fullWidth
          label="Confirm New Password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          sx={{ ...inputSx }}
        />
      </DialogContent>
      <DialogActions sx={{ 
        p: 2, 
        gap: 1, 
        borderTop: `1px solid ${colors.border}` 
      }}>
        <Button
          onClick={handleClose}
          sx={{ 
            color: colors.muted,
            '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)' },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          sx={{
            bgcolor: '#3b82f6',
            '&:hover': { bgcolor: '#2563eb' },
            '&.Mui-disabled': { bgcolor: isDark ? '#1a1a1a' : '#e5e7eb' },
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          {loading ? <CircularProgress size={20} /> : 'Change Password'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default function MainLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
  const [profileDrawerView, setProfileDrawerView] = useState<'profile' | 'account'>('profile');
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { mode, toggleTheme } = useTheme();
  const isDark = mode === 'dark';

  // ─── Approved-but-not-yet-onboarded vendor requests -- shown as a red badge on the
  // sidebar's "Vendors" item, same count as the Vendors page's own "Onboarding Requests"
  // tab badge (that's where these actually get finished off into a real vendor).
  // One live-update stream for the whole signed-in app (changes by teammates and background scans).
  useRealtimeSync(user?.id);

  // Shares its cache entry with that tab, so approving or onboarding a request updates both at once.
  const approvedRequestsQuery = useQuery({ ...vendorRequestQueries.list('approved'), enabled: !!user });
  const openVendorRequestsCount = approvedRequestsQuery.data?.length ?? 0;

  // Help is a paid-plan feature (free trials don't get it); the guide endpoint enforces the same rule.
  const helpAccessQuery = useQuery({ ...helpQueries.access(), enabled: !!user });
  const sidebarSections: { title: string | null; items: MenuItem[]; bottom?: boolean }[] = helpAccessQuery.data?.enabled
    ? [...menuSections, { title: null, items: [{ path: '/help', label: 'Help', icon: HelpIcon }], bottom: true }]
    : menuSections;

  // ─── Theme-aware color tokens ────────────────────────────────────
  const colors = {
    appBarBg: isDark ? '#000000' : '#FFFFFF',
    appBarBorder: isDark ? '#1F1F1F' : '#E0E0E0',
    appBarText: isDark ? '#FFFFFF' : '#333333',
    hamburgerIdle: isDark ? '#FFFFFF' : '#333333',
    hamburgerHover: isDark ? alpha('#FFFFFF', 0.08) : alpha('#000', 0.05),
    sidebarBg: isDark ? '#000000' : '#FFFFFF',
    sidebarBorder: isDark ? '#1F1F1F' : '#d4d4d4',
    sidebarDivider: isDark ? '#1F1F1F' : '#c9c9c9',
    textColor: isDark ? '#CBD5E1' : '#475569',
    textHover: isDark ? '#FFFFFF' : '#0F172A',
    hoverBgColor: isDark ? '#1A1A1A' : '#F1F5F9',
    activeBgColor: isDark ? '#0C2A4A' : '#E6F1FB',
    activeTextColor: isDark ? '#DBEAFE' : '#0C447C',
    activeIconColor: isDark ? '#85B7EB' : '#185FA5',
    sectionTitle: isDark ? '#64748B' : '#94A3B8',
    userName: isDark ? '#FFFFFF' : '#000000',
    userSubtext: isDark ? '#9A9FBE' : '#8A8FAB',
    mainBg: isDark ? '#000000' : '#F5F6FA',
    accent: '#2B5C9E',
    menuBg: isDark ? '#0F0F0F' : '#FFFFFF',
    menuText: isDark ? '#FFFFFF' : '#000000',
    menuBorder: isDark ? '#1F1F1F' : '#e0e0e0',
  };

  const logoSrc = isDark ? '/logo2.png' : '/logo.png';

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleSidebarToggle = () => {
    if (isLocked) {
      setIsLocked(false);
      setSidebarOpen(false);
    } else {
      setIsLocked(true);
      setSidebarOpen(true);
    }
  };

  const handleMouseEnter = () => {
    if (!isLocked) {
      setIsHovering(true);
      setSidebarOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isLocked) {
      setIsHovering(false);
      setSidebarOpen(false);
    }
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    logout();
    navigate('/login');
  };

  const handleChangePassword = () => {
    handleMenuClose();
    setChangePasswordOpen(true);
  };

  const handleOpenProfileDrawer = () => {
    handleMenuClose();
    setProfileDrawerView('profile');
    setProfileDrawerOpen(true);
  };

  const handleOpenAccountSettings = () => {
    handleMenuClose();
    setProfileDrawerView('account');
    setProfileDrawerOpen(true);
  };

  const isActivePath = (path: string) => {
    if (path === '/') return location.pathname === '/';
    if (path === '/reports') return location.pathname === '/reports';
    if (path === '/reports/comparison') return location.pathname === '/reports/comparison';
    if (path === '/monitoring') return location.pathname === '/monitoring';
    if (path === '/vendors/add') return location.pathname === '/vendors/add';
    if (path === '/vendors') return location.pathname === '/vendors';
    if (path === '/scans') return location.pathname.startsWith('/scans');
    if (path === '/users') return location.pathname.startsWith('/users');
    if (path === '/audit-logs') return location.pathname.startsWith('/audit-logs');
    return location.pathname.startsWith(path);
  };

  const isVisible = sidebarOpen || isHovering || isLocked;

  const drawerContent = (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        pt: 1,
        bgcolor: colors.sidebarBg,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 20,
        }}
      />

      {/* Only the menu scrolls; the signed-in user below stays pinned to the bottom. The scrollbar is a thin 4px
          overlay-style bar: a default one takes ~17px of the narrow collapsed rail and clips the icons and badge. */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflowX: 'hidden',
          overflowY: 'auto',
          overscrollBehavior: 'contain',
          scrollbarWidth: 'thin',
          scrollbarColor: `${isDark ? '#333' : '#CBD5E1'} transparent`,
          '&::-webkit-scrollbar': { width: 4 },
          '&::-webkit-scrollbar-track': { background: 'transparent' },
          '&::-webkit-scrollbar-thumb': { background: isDark ? '#333' : '#CBD5E1', borderRadius: 4 },
        }}
      >
        {/* Every row keeps the same size and padding collapsed and expanded, and the label is always rendered (it
            only fades in), so hovering never moves an icon. 8px list + 16px button padding centres the 24px icon in
            the collapsed rail. */}
        <List sx={{ px: 1, py: 1.5, flex: 1, display: 'flex', flexDirection: 'column' }}>
          {sidebarSections.map((section, si) => (
            <React.Fragment key={section.title || (section.bottom ? 'bottom' : 'top')}>
              {/* Help is pinned to the bottom of the sidebar, below every section. */}
              {section.bottom && <Box sx={{ mt: 'auto', pt: 1.5 }}><Divider sx={{ borderColor: colors.sidebarDivider, mb: 1 }} /></Box>}
              {section.title && (
                // Fixed height in both states so expanding on hover never shifts the icons: the title fades in when
                // expanded, a short rule marks the section boundary in the collapsed rail.
                <Box sx={{ position: 'relative', height: 30, mt: si === 1 ? 0.5 : 1.25 }}>
                  <Typography aria-hidden={!isVisible} noWrap sx={{
                    position: 'absolute', left: 16, bottom: 6, fontSize: '0.72rem', fontWeight: 600, letterSpacing: '.04em',
                    textTransform: 'uppercase', color: colors.sectionTitle, opacity: isVisible ? 1 : 0, transition: 'opacity 0.15s ease-out',
                  }}>
                    {section.title}
                  </Typography>
                  <Box sx={{
                    position: 'absolute', left: 24, bottom: 12, width: 24, height: '1px', bgcolor: colors.sidebarDivider,
                    opacity: isVisible ? 0 : 1, transition: 'opacity 0.15s ease-out',
                  }} />
                </Box>
              )}
              {section.items.map((item) => {
                const isActive = isActivePath(item.path);
                return (
                  <ListItem key={item.path} disablePadding sx={{ mb: '2px' }}>
                    <ListItemButton
                      onClick={() => navigate(item.path)}
                      title={isVisible ? undefined : item.label}
                      sx={{
                        borderRadius: '8px',
                        height: 40,
                        py: 0,
                        // Collapsed: a 40px square centred on the icon, so the selected/hover highlight sits evenly
                        // around it (a full-width row looked shifted once the scrollbar narrowed the rail). The icon
                        // stays at 8 + 8 + 8 = 24px from the edge in both states, so expanding never moves it.
                        width: isVisible ? '100%' : 40,
                        flex: isVisible ? 1 : '0 0 40px',
                        ml: isVisible ? 0 : '8px',
                        px: isVisible ? '16px' : '8px',
                        justifyContent: 'flex-start',
                        bgcolor: isActive ? colors.activeBgColor : 'transparent',
                        color: isActive ? colors.activeTextColor : colors.textColor,
                        transition: 'background-color 0.12s, color 0.12s',
                        '&:hover': {
                          bgcolor: isActive ? colors.activeBgColor : colors.hoverBgColor,
                          color: isActive ? colors.activeTextColor : colors.textHover,
                        },
                      }}
                    >
                      <ListItemIcon sx={{
                        color: isActive ? colors.activeIconColor : 'inherit',
                        minWidth: 24,
                        justifyContent: 'center',
                        '& svg': { fontSize: 22 },
                      }}>
                        {item.path === '/vendors' && openVendorRequestsCount > 0 ? (
                          <Badge
                            badgeContent={openVendorRequestsCount}
                            color="error"
                            // Smaller than MUI's default and pulled in, so it sits inside the row rather than on its edge.
                            sx={{ '& .MuiBadge-badge': { height: 16, minWidth: 16, px: '4px', fontSize: 10, fontWeight: 700, top: 2, right: 2 } }}
                          >
                            <item.icon />
                          </Badge>
                        ) : (
                          <item.icon />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.label}
                        aria-hidden={!isVisible}
                        sx={{ ml: 1.75, my: 0, opacity: isVisible ? 1 : 0, transition: 'opacity 0.15s ease-out' }}
                        primaryTypographyProps={{
                          fontSize: '0.875rem',
                          lineHeight: '20px',
                          noWrap: true,
                          fontWeight: isActive ? 600 : 500,
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </React.Fragment>
          ))}
        </List>
      </Box>

        {user && (
          <>
            <Divider sx={{ borderColor: colors.sidebarDivider }} />
            {/* Same rule as the menu: fixed avatar size and padding (20px on the left centres the 32px avatar in the
                collapsed rail), name always rendered and only faded in. */}
            <Box sx={{ px: 1, py: 1.5, flexShrink: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  px: '12px',
                  py: 1,
                }}
              >
                <Avatar sx={{
                  bgcolor: colors.accent,
                  width: 32,
                  height: 32,
                  flexShrink: 0,
                  borderRadius: '50%',
                  color: '#FFFFFF',
                }}>
                  {user.name?.charAt(0).toUpperCase()}
                </Avatar>
                <Box aria-hidden={!isVisible} sx={{ minWidth: 0, opacity: isVisible ? 1 : 0, transition: 'opacity 0.15s ease-out' }}>
                  <Typography variant="body2" fontWeight={600} noWrap sx={{ color: colors.userName }}>
                    {user.name}
                  </Typography>
                  <Typography variant="caption" noWrap component="div" sx={{ color: colors.userSubtext }}>
                    {user.company || 'Risk Manager'}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </>
        )}
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* ─── CHANGE PASSWORD DIALOG ──────────────────────────────────── */}
      <ChangePasswordDialog
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
        isDark={isDark}
      />

      {/* ─── PROFILE DRAWER ──────────────────────────────────────────── */}
      <ProfileDrawer
        open={profileDrawerOpen}
        onClose={() => setProfileDrawerOpen(false)}
        onOpenChangePassword={handleChangePassword}
        initialView={profileDrawerView}
      />

      {/* ─── FLUXWATCH ASSISTANT ─────────────────────────────────────── */}
      <FluxAssistant />
      <AIGuardModal />
      <IdleSignOut />

      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          boxShadow: 'none',
          borderBottom: '1px solid',
          borderBottomColor: colors.appBarBorder,
          bgcolor: colors.appBarBg,
          color: colors.appBarText,
          height: 64,
        }}
      >
        <Toolbar sx={{ height: 64, minHeight: 50 }}>
          {/* ─── SIDEBAR TOGGLE ────────────────────────────────────────────── */}
          <IconButton
            onClick={handleSidebarToggle}
            edge="start"
            sx={{
              color: isLocked ? colors.accent : colors.hamburgerIdle,
              mr: 0.5,
              '&:hover': { bgcolor: colors.hamburgerHover },
            }}
          >
            <MenuIcon />
          </IconButton>

          {/* ─── LOGO ──────────────────────────────────────────────────────── */}
          <Box
            component="img"
            src={logoSrc}
            alt="Axentro"
            sx={{
              height: 58,
              width: 'auto',
              objectFit: 'contain',
            }}
          />

          <Box sx={{ flexGrow: 1 }} />

          {/* ─── TRIAL (Tropos): centred in the header, independent of what sits left and right ─── */}
          <Box sx={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', display: { xs: 'none', lg: 'block' } }}>
            <TrialBadge isDark={isDark} enabled={!!user} />
          </Box>

          {/* ─── MY ORGANIZATION ─────────────────────────────────────────── */}
          <OrganizationButton isDark={isDark} enabled={!!user} />

          {/* ─── NOTIFICATION BELL ────────────────────────────────────────── */}
          <NotificationBell />

          {/* ─── DARK MODE TOGGLE ──────────────────────────────────────────── */}
          <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton
              onClick={toggleTheme}
              sx={{
                color: isDark ? '#e2e8f0' : '#333333',
                mx: 1,
                '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)' },
              }}
            >
              {isDark ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
          </Tooltip>

          {/* ─── ACCOUNT AVATAR ───────────────────────────────────────────── */}
          <Tooltip title="Account">
            <IconButton onClick={handleMenuOpen} sx={{ ml: 0.5 }}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: colors.accent, borderRadius: '50%', color: '#FFFFFF' }}>
                {user?.name?.charAt(0).toUpperCase() || <PersonIcon />}
              </Avatar>
            </IconButton>
          </Tooltip>

          {/* ─── ACCOUNT MENU ──────────────────────────────────────────────── */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            PaperProps={{
              sx: {
                width: 220,
                mt: 1,
                bgcolor: colors.menuBg,
                color: colors.menuText,
                border: `1px solid ${colors.menuBorder}`,
              },
            }}
          >
            <MenuItem 
              onClick={handleOpenProfileDrawer}
              sx={{
                '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
              }}
            >
              <ListItemIcon><PersonIcon fontSize="small" sx={{ color: colors.menuText }} /></ListItemIcon>
              <ListItemText sx={{ color: colors.menuText }}>Profile</ListItemText>
            </MenuItem>
            
            <MenuItem 
              onClick={handleChangePassword}
              sx={{
                '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
              }}
            >
              <ListItemIcon><LockIcon fontSize="small" sx={{ color: colors.menuText }} /></ListItemIcon>
              <ListItemText sx={{ color: colors.menuText }}>Change Password</ListItemText>
            </MenuItem>
            
            <MenuItem 
              onClick={handleOpenAccountSettings}
              sx={{
                '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
              }}
            >
              <ListItemIcon><SettingsIcon fontSize="small" sx={{ color: colors.menuText }} /></ListItemIcon>
              <ListItemText sx={{ color: colors.menuText }}>Account Settings</ListItemText>
            </MenuItem>
            
            <Divider sx={{ borderColor: colors.menuBorder }} />
            
            <MenuItem 
              onClick={handleLogout} 
              sx={{ 
                color: 'error.main',
                '&:hover': { bgcolor: isDark ? alpha('#FFFFFF', 0.05) : alpha('#000', 0.05) },
              }}
            >
              <ListItemIcon><LogoutIcon fontSize="small" sx={{ color: 'error.main' }} /></ListItemIcon>
              <ListItemText primary="Logout" primaryTypographyProps={{ color: 'error.main' }} />
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          width: { sm: isVisible ? drawerWidth : collapsedDrawerWidth },
          flexShrink: { sm: 0 },
          transition: 'width 0.2s ease-out',
          mt: '64px',
        }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              bgcolor: colors.sidebarBg,
              borderRight: 'none',
              borderRadius: 0,
              mt: '64px',
              height: 'calc(100vh - 64px)',
            },
          }}
        >
          {drawerContent}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: isVisible ? drawerWidth : collapsedDrawerWidth,
              bgcolor: colors.sidebarBg,
              borderRight: '1px solid',
              borderRightColor: colors.sidebarBorder,
              position: 'fixed',
              height: 'calc(100vh - 64px)',
              top: 64,
              left: 0,
              overflowX: 'hidden',
              borderRadius: 0,
              transition: 'width 0.2s ease-out, background-color 0.2s ease-out',
              // Still scrolls on short screens, but a visible scrollbar would take width from the 65px rail and
              // push the icons off centre.
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            },
          }}
          open
        >
          {drawerContent}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${isVisible ? drawerWidth : collapsedDrawerWidth}px)` },
          bgcolor: colors.mainBg,
          minHeight: '100vh',
          mt: '64px',
          transition: 'width 0.2s ease-out, background-color 0.2s ease-out',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}